export const defaultFiltersValue = {
  number: { min: null, max: null, type: null },
  checkbox: "all",
  date: null,
  tags: [],
  enrollments: [],
}
